import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentUnit from 'material-ui/svg-icons/action/assessment';

/**
 * An icon button that passes a boolean state via an emitted event.
 */
class LocationAuditsIconButton extends Component {
    constructor(props) {
        super(props);

        this.handleToggleClick = this.handleToggleClick.bind(this);

        this.state = {
            expanded: false
        };
    }

    componentWillMount() {
        this.setState({
            expanded: this.props.expanded
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.expanded !== this.props.expanded) {
            this.setState({
                expanded: nextProps.expanded
            });
        }
    }

    handleToggleClick = (e, id, is_auditing, is_final_auditing) => {
        // Emit an event via the emitter passed as a prop to this component
        const eventEmitter = this.props.eventEmitter;
        eventEmitter.emit(this.props.toggleEventName, id, is_auditing, is_final_auditing);
        // Pass toggle event up to List (if state/props is used)
        this.props.onToggleClick(e, id, is_auditing, is_final_auditing, !this.props.expanded);
    };

    render() {
        const {
            record
        } = this.props;

        return (
            <IconButton
                style={{overflow: 'inherit'}}
                tooltip="View Open Audit(s)"
                tooltipPosition="top-center"
                onClick={(e) => this.handleToggleClick(e, record.id, record.is_auditing, record.is_final_auditing)}
            >
                <ContentUnit color={FuseTheme.palette.primary1Color}/>
            </IconButton>
        )
    }
}

LocationAuditsIconButton.propTypes = {
    eventEmitter: PropTypes.any,
    expanded: PropTypes.bool,
    onToggleClick: PropTypes.func,
    record: PropTypes.object,
    toggleEventName: PropTypes.string,
};

LocationAuditsIconButton.defaultProps = {
    expanded: false,
    toggleEventName: 'locationAuditToggle',
};

export default LocationAuditsIconButton;


// WEBPACK FOOTER //
// ./src/Fuse/buttons/LocationAuditsIconButton.js